import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';

import { ProductType } from '../types/product.type';
import { SxHttpService } from '../../../infrastructure/services/sxHttp.service';
import { SxDesignerService } from './designer-service';

interface ReqFullContext {
    systemCode: string;
    businessCode: string;
    codProducto: string;
    codFlow: string;
    codServicio: string;
    codComando: string;
    documentKind: string;
    standardkey: string;
    pageId: string;
    listPath: string;
}

@Injectable()
export class SxfDesignerService implements SxDesignerService {
    url = 'api/sxfdesigner';

    constructor(private http: Http,
        private sxHttp: SxHttpService) {
    }

    getAll() {
        return this.sxHttp.get('api/sxfdesigner/')
            .map(response => response.json().data)
            .catch(this.handleError)
            .toPromise();
    }

    get(id: number) {
        return this.sxHttp.get('api/sxfdesigner/' + id)
            .map(response => response.json().data as ProductType)
            .catch(this.handleError)
            .toPromise();
    }

    getBySistema(codSistema: string, codNegocio: string, codProducto: string,
        codServicio: string, codComando: string,docuemntKind: string, listPath: string) {
        let actionUrl = 'api/sxfdesigner/system';
        const reqBySistema : any = {
            CodInstalacionV5: codSistema,
            CodNegocio: codNegocio,
            codProducto: codProducto,
            codFlow : null,
            codComando: codComando,
            codServicio: codServicio,
            standardkey: null,
            documentKind: docuemntKind,
            listPath: listPath,
            pageId : null,
        }

        return this.sxHttp.post(actionUrl, reqBySistema)
            .map(response => response.json().data as ProductType)
            .catch(this.handleError)
            .toPromise();
    }

    save(product: ProductType) {
        return this.sxHttp.post('api/sxfdesigner/', product)
            .catch(this.handleError)
            .toPromise()
            .then(this.extractData);
    }

    cambiarAVersion(codForm: string, historialId: number) {
        const url = `${this.url}/${codForm}/${historialId}`;

        return this.sxHttp.put(url, {})
            .toPromise()
            .then(response => response.json().data)
            .catch(this.handleError);
    }

    getCustomAtributos(system: string, deal: string, product: string, codServicio: string, 
        codComando: string,docuemntKind:string, standardkey : string, listPath: string, codflow: string): Promise<any> {
            
            const req : ReqFullContext = {
                systemCode: system,
                businessCode: deal,
                codProducto: product,
                codFlow : codflow,
                codComando: codComando,
                codServicio: codServicio,
                standardkey: standardkey,
                documentKind: docuemntKind,
                listPath: listPath,
                pageId : null,
            }
        let actionUrl = `api/productDesigns/system`;
            
        if (deal) {
            actionUrl = `api/productDesigns/forNegocio`;
        }

        return this.sxHttp.post(actionUrl, req)
            .map(response => response.json().data)
            .toPromise();
    }

    getViewEngines():Promise<any> {
      return this.sxHttp.get('api/viewEngine/GetAll')
        .map(response => response.json().data)
        .toPromise();
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

    private extractData(res: Response) {
        const body = res.json();
        return body || {};
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/services/sxfdesigner-service.ts